const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

export default function Sobre() {
  return (
    <section id="sobre" className="py-[60px] bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src="https://storage.readdy-site.link/project_files/0eb339c4-c5ed-46f4-89fb-453ecbc64de7/a8ad9799-58b7-4f62-a9c1-f4a964121edb_moreira-tofoli.jpg?v=bc38c92878779901ef01821e50245616"
                alt="Moreira Tófoli Advogados – Equipe"
                className="w-full h-[520px] object-cover object-top"
              />
            </div>
            {/* Camel border accent */}
            <div className="absolute -top-4 -left-4 w-20 h-20 border-t-2 border-l-2 border-[#B39B62] rounded-tl-lg hidden lg:block"></div>
          </div>

          {/* Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#B39B62]"></span>
              <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
                O escritório
              </span>
            </div>

            <h2 className="font-serif text-4xl lg:text-5xl text-[#0A1829] font-light leading-tight mb-6">
              Atuação jurídica com{' '}
              <span className="italic text-[#B39B62]">visão estratégica</span>
            </h2>

            <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-5">
              O escritório <strong className="font-semibold text-[#0A1829]">Moreira Tófoli Advogados</strong> oferece atendimento jurídico completo, com atuação tanto na esfera criminal quanto civil, sempre com foco na proteção dos interesses do cliente, prevenção de riscos e tomada de decisões seguras.
            </p>
            <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-10">
              Nossa atuação abrange Direito Penal, Penal Empresarial e Direito Civil, com soluções estratégicas pensadas para pessoas e empresas. Cada caso é tratado com o rigor técnico e o cuidado humano que a situação exige.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 border-t border-[#E9D59C]/60 pt-8 mb-8">
              <div>
                <div className="font-serif text-4xl text-[#B39B62] font-light mb-1">24h</div>
                <div className="font-sans text-sm text-[#0A1829]/60">Disponibilidade para<br />situações urgentes</div>
              </div>
              <div>
                <div className="font-serif text-4xl text-[#B39B62] font-light mb-1">100%</div>
                <div className="font-sans text-sm text-[#0A1829]/60">Dedicação em<br />cada caso</div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#0A1829] hover:bg-[#B39B62] text-white hover:text-[#0A1829] font-sans font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-base"></i>
              Falar com um advogado
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
